module.exports = __webpack_public_path__ + "assets/img/sliders-h.1f3f0c35.svg";